import script from "./FooterTab.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterTab.vue?vue&type=script&setup=true&lang=js"

import "./FooterTab.vue?vue&type=style&index=0&id=16b1c89d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b1c89d"]])

export default __exports__